<template>
  <div>
    <PCNavbar selectIndex="2-1"/>
    <MobileNavBar :currentActive="2-1" />
    <Production />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Production from "@/components/production/index.vue";

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Production
  },
}
</script>

<style>
</style>